import { Component, ElementRef, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import moment from 'moment';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Categories,
  LoginModel,
  MainDepartment,
  Stores
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { DatePipe } from '@angular/common';
import { ReportsApiService } from '../../api-services/reports-api.service';
import { WeekColorService } from '../../company-config/WeekColors/services/week-color.service';
import {
  ProductionCycle,
  ProductionCycleSchedule
} from '../../company-config/WeekColors/models/week-color.model';
import { OverrideStatus } from 'src/app/enum/enum';
@Component({
  selector: 'app-sell-through-reportv2',
  templateUrl: './sell-through-reportv2.component.html',
  styleUrls: ['./sell-through-reportv2.component.css']
})
export class SellThroughReportv2Component {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  reportType: string[] = [
    'Sales Summary',
    'User',
    'Outlet',
    'Register',
    'Customer',
    'Customer Group',
    'Promotions',
    '....',
    'Product',
    'Sku Name',
    'Brand',
    'Supplier',
    'Category',
    'Tag'
  ];
  measure: string[] = [
    'Revenue',
    'Revenue (incl. tax)',
    'avg. Item per sale',
    'avg. Sale value',
    'avg. Sale value (incl. tax)',
    'cost of goods sold',
    'customer count',
    'discounted',
    'discounted %',
    'first sale',
    'last sale',
    'gross profit',
    'items sold',
    'margin %',
    'return count',
    'return %',
    'Sale Count',
    'Sales with customer attached',
    'Tax'
  ];
  reportTypeOption: string = 'All Stores';

  OutOfStockColumnName: any = [
    { columnId: 1, columnName: 'Produced' },
    { columnId: 2, columnName: 'Produced Total' },
    { columnId: 3, columnName: 'Avg. Price' },
    { columnId: 4, columnName: 'Sell through' },
    { columnId: 5, columnName: 'Total Sold' },
    { columnId: 16, columnName: 'Avg. Price Sold' },
    { columnId: 6, columnName: 'Item Discounted' },
    { columnId: 7, columnName: 'Discounted Amount' },
    { columnId: 10, columnName: 'Avg. Day on Floor' },
    { columnId: 11, columnName: 'Current on-hand' },
    { columnId: 12, columnName: 'Potential Revenue' },
    /*  { "columnId": 13, "columnName": "Margin" },*/
    { columnId: 14, columnName: 'Sell-through %' },
    { columnId: 15, columnName: 'Trend' }
  ];
  modalColumns: any = [
    { columnId: 1, columnName: 'Produced' },
    { columnId: 2, columnName: 'Produced Total' },
    { columnId: 3, columnName: 'Avg. Price' },
    { columnId: 4, columnName: 'Sell through' },
    { columnId: 5, columnName: 'Total Sold' },
    { columnId: 16, columnName: 'Avg. Price Sold' },
    { columnId: 6, columnName: 'Item Discounted' },
    { columnId: 7, columnName: 'Discounted Amount' },
    { columnId: 10, columnName: 'Avg. Day on Floor' },
    { columnId: 11, columnName: 'Current on-hand' },
    { columnId: 12, columnName: 'Potential Revenue' },
    /*  { "columnId": 13, "columnName": "Margin" },*/
    { columnId: 14, columnName: 'Sell-through %' }
  ];

  salesGraph: any;
  startDate: any;
  endDate: any;
  charts: Chart[] = [];
  noChartData: boolean = true;
  empTableData: any = [
    {
      emp: 'Raquel Marks',
      img: 'assets/pos/products/ic_user1.png',
      storeName: 'Flamingo Retail',
      prdData: ['3234', '$7,456.00', '13 days', '$456.00', '21%', '54%', '-']
    },
    {
      emp: 'Andre Fadel',
      img: 'assets/pos/products/ic_user2.png',
      storeName: 'Sole Mates Shoe Co.',
      prdData: ['3234', '$7,456.00', '13 days', '$456.00', '21%', '54%', '-']
    },
    {
      emp: 'Pat Grady',
      img: 'assets/pos/products/ic_user3.png',
      storeName: 'Timeless Threads',
      prdData: ['3234', '$7,456.00', '13 days', '$456.00', '21%', '54%', '-']
    }
  ];
  userInfo: LoginModel = new LoginModel();
  stores: Array<Stores> = [];
  deptName: string = 'All departments';
  categoryName: string = 'All categories';
  storeName: string = 'All stores';
  deptID: number = 0;
  storeNames: Array<string> = [];
  storeIds: Array<number> = [];
  storeId: string = '0';
  /*sellThroughChart properties*/
  storeID: number = 0;
  userID: number = 0;
  categoryId: number = 0;
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  headerCheckboxSelected: boolean = false;
  producersColumns = [
    { columnID: 1, columnName: 'Produced' },
    { columnID: 2, columnName: 'Total' },
    { columnID: 3, columnName: 'Avg. Days on Floor' },
    { columnID: 4, columnName: 'Potential Revenue' },
    /* { 'columnID': 5, 'columnName': 'Margin' },*/
    { columnID: 6, columnName: 'Sell-through %' },
    { columnID: 7, columnName: 'Trend' }
  ];
  reportHead: string = 'ALL STORES SELECTED | ALL DEPARTMENTS / all categories';
  mainDepartmentList: Array<MainDepartment> = [];
  categorieslist: Array<Categories> = [];
  disableCategory: boolean = true;
  sellThroughData: any;
  sellThroughDeptData: any;
  sellThroughDeptTableData: any;
  modalStoreName: string = '';
  modalUserName: string = '';
  noDataFound: boolean = false;
  usersArray: any;
  chartUserName: string = 'Over All';
  chartStoreName: string = '';
  chartLabels: Array<string> = [];
  sellThroughChart: { date: string; sellThroughPercentage: number }[] = [];
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  weekColorSchedule: Array<ProductionCycleSchedule> = [];
  productionCycleId: number = 0;
  weekColorHeaderSelected: boolean = false;
  showWeekColor: boolean = true;

  constructor(
    private weekColorService: WeekColorService,
    private masterService: MasterDataSeriveService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private reportServiceV2: ReportsApiService,
    private datepipe: DatePipe
  ) {}
  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      {
        crumbName: 'Sell-Through Report V2 (Preview)',
        link: '/admin/home/sell-throughv2'
      }
    ]);
    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (
      this.userInfo as any
    )?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    this.getMainDepartments();
    this.startDate = moment().format('MM-DD-YYYY');
    this.endDate = moment().format('MM-DD-YYYY');
  }

  runReport() {
    this.reportHasRun = true;
    this.getSellThroughReport();
  }

  /* date range picker */
  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel'
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,

    // Restrict selectable range: from 1 month ago (next day) to yesterday
    minDate: moment().subtract(362, 'days').startOf('day'),
    maxDate: moment().subtract(1, 'day').endOf('day'),

    ranges: {
      Yesterday: [
        moment().subtract(1, 'days').startOf('day'),
        moment().subtract(1, 'days').endOf('day')
      ],
      'Last 7 Days': [
        moment().subtract(7, 'days').startOf('day'),
        moment().subtract(1, 'days').endOf('day')
      ],
      'Last 30 Days': [
        moment().subtract(30, 'days').startOf('day'),
        moment().subtract(1, 'days').endOf('day')
      ],
      'This Month': [
        moment().startOf('month').startOf('day'),
        moment().subtract(1, 'day').endOf('day')
      ],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    },
    opens: 'left'
  };

  public selectedDate(value: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  /*filters methods*/

  getStores() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.masterService.getallstores(user.companyID).subscribe((res) => {
      this.stores = res as Stores[];
      this.storeID = this.stores[0]?.storeId;
      this.chartStoreName = this.stores[0]?.storeName;
    });
  }

  getMainDepartments() {
    this.masterService.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
      },
      (err) => {}
    );
  }

  getCategoriesByDeptId(deptId: number) {
    this.masterService
      .getCategoriesByDeptUserID(deptId, this.userInfo.userId, false, 0)
      .subscribe((res) => {
        this.categoryName = 'All categories';
        this.categorieslist = res as Categories[];
      });
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;

    // Update the selectedDepartmentIDs array based on headerCheckboxSelected state
    if (this.headerCheckboxSelected) {
      /* this.goal.isSelected = true;*/
      this.storeIds = this.stores.map((str) => str.storeId);
    } else {
      this.storeIds = [];
      /*this.goal.gIsSelected = false;*/
    }
    if (this.storeIds.length) {
      this.storeId = this.storeIds.join(', ');
    } else {
      this.storeName = 'All stores';
      this.storeId = '0';
    }
  }

  selectAllDepartments() {
    this.deptName = 'All departments';
    this.deptID = 0;
    this.disableCategory = true;
  }

  selectAllcategories() {
    if (this.categorieslist.length) {
      let index = this.reportHead.indexOf('/');

      // If "/" is found, remove the substring after "/"
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index);
      }

      this.categoryName = 'All categories';
      this.categoryId = 0;
    }
  }

  setOverAllOption() {
    this.chartUserName = 'Over All';
    this.userID = 0;
    this.getSellThroughChart();
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      this.deptName = filterObj.departmentDescr;
      this.deptID = filterObj.departmentId;
      this.disableCategory = false;
    }
    if (option === 2) {
      const nameIndex = this.storeNames.findIndex(
        (item) => item === filterObj.storeName
      );

      if (nameIndex !== -1) {
        this.storeNames.splice(nameIndex, 1);
      } else {
        this.storeNames.push(filterObj.storeName);
      }

      if (this.storeNames.length > 1) {
        this.storeName =
          this.storeNames.slice(0, 1) + ' +' + `${this.storeNames.length - 1}`;
      } else {
        this.storeName = this.storeNames.join(', ');
      }

      const iDIndex = this.storeIds.indexOf(filterObj.storeId);

      // If store is already present, remove it from this.deptIDs
      if (iDIndex !== -1) {
        this.storeIds.splice(iDIndex, 1);
      } else {
        this.storeIds.push(filterObj.storeId);
      }

      if (this.storeIds.length) {
        this.storeId = this.storeIds.join(', ');
      } else {
        this.storeName = 'All stores';
        this.storeId = '0';
        this.disableCategory = true;
      }
    }
    if (option === 3) {
      this.categoryName = filterObj.categoryName;
      this.categoryId = filterObj.categoryId;
    }
    if (option == 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.id;
    }
  }

  /*Sell through data methods*/

  getSellThroughReport() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.reportServiceV2
      .getSellThroughReportV2(
        this.userInfo.companyID,
        this.storeId,
        this.deptID,
        this.categoryId,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId
      )
      .subscribe({
        next: (res: any) => {
          const stores = res.storeSummaries;
          const producers = res.producerSummaries;
          const department = res.departmentSummaries;
          const category = res.categorySummaries;
          const storeTrend = res.storeTrends;
          const producerTrend = res.producerTrends;
          this.formateSellThroughTableData(
            stores,
            producers,
            storeTrend,
            producerTrend
          );
          this.formateSellThroughModalData(department, category);
          this.formateTopProducersData(
            stores,
            producers,
            storeTrend,
            producerTrend
          );
          setTimeout(() => {
            this.renderDynamicTrendChart(
              this.sellThroughData,
              this.empTableData
            );
          }, 100);
          this.getUsersByStore(this.storeID);
          if (res.storeSummaries.length == 0) {
            this.noDataFound = true;
          } else {
            this.noDataFound = false;
          }

          if (this.sellThroughData.length) {
            this.storeID = this.sellThroughData[0].storeID;
            this.chartStoreName = this.sellThroughData[0].storeName;
            this.getSellThroughChart();
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  formateTopProducersData(
    stores: any[],
    producers: any[],
    storeTrend: any[],
    producerTrend: any[]
  ): void {
    // Pre-index stores by ProductionStoreID for O(1) lookups
    const storeMap = new Map<number, any>();
    stores.forEach((store) => {
      storeMap.set(store.productionStoreID, store);
    });

    // Pre-index producer trends by composite key for O(1) lookups
    const producerTrendMap = new Map<string, any[]>();
    producerTrend.forEach((trend) => {
      const key = `${trend.productionStoreID}_${trend.createdByUserID}`;
      if (!producerTrendMap.has(key)) {
        producerTrendMap.set(key, []);
      }
      producerTrendMap.get(key)!.push(trend);
    });

    // Group producers by ProductionStoreID and find the one with max ProducedQty
    const producerMap = new Map<number, any>();
    producers.forEach((producer) => {
      const existingProducer = producerMap.get(producer.productionStoreID);
      if (
        !existingProducer ||
        producer.producedQty > existingProducer.producedQty
      ) {
        producerMap.set(producer.productionStoreID, producer);
      }
    });

    // Helper function to format currency
    const formatCurrency = (value: number) =>
      `$${value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;

    // Convert map values to array and process
    const uniqueProducers = Array.from(producerMap.values());

    this.empTableData = uniqueProducers
      .map((producer) => {
        // O(1) lookup instead of find()
        const store = storeMap.get(producer.productionStoreID);

        // O(1) lookup for producer trends
        const trendKey = `${producer.productionStoreID}_${producer.userID}`;
        const trends = producerTrendMap.get(trendKey) || [];

        const producerTrendData = {
          producerID: trendKey,
          data: trends.map((trend) => ({
            date: this.datepipe.transform(trend.createdDate, 'MMM d')!,
            sellThroughPercentage: trend.sellThroughPercentage.toFixed(2)
          }))
        };

        return {
          UserName: producer.userName,
          storeName: store ? store.storeName : 'Unknown',
          prdData: [
            { columnID: 1, value: producer.producedQty },
            { columnID: 2, value: formatCurrency(producer.producedPrice) },
            { columnID: 3, value: `${producer.avgDaysOnFloor} days` },
            { columnID: 4, value: formatCurrency(producer.potentialRevenue) },
            {
              columnID: 6,
              value: `${producer.sellThroughPercentage.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}%`
            },
            { columnID: 7, value: producerTrendData }
          ]
        };
      })
      .sort((a, b) => b.prdData[0].value - a.prdData[0].value);
  }

  formateSellThroughTableData(
    stores: any,
    producers: any,
    storeTrend: any,
    producerTrend: any
  ) {
    // Pre-index data by IDs for O(1) lookups instead of O(n) filtering
    const producersByStore = new Map<any, any[]>();
    const storeTrendByStore = new Map<any, any[]>();
    const producerTrendByKey = new Map<string, any[]>();

    // Single pass through producers array
    producers.forEach((producer: any) => {
      if (!producersByStore.has(producer.productionStoreID)) {
        producersByStore.set(producer.productionStoreID, []);
      }
      producersByStore.get(producer.productionStoreID)!.push(producer);
    });

    // Single pass through store trends
    storeTrend.forEach((trend: any) => {
      if (!storeTrendByStore.has(trend.productionStoreID)) {
        storeTrendByStore.set(trend.productionStoreID, []);
      }
      storeTrendByStore.get(trend.productionStoreID)!.push(trend);
    });

    // Single pass through producer trends
    producerTrend.forEach((trend: any) => {
      const key = `${trend.productionStoreID}-${trend.createdByUserID}`;
      if (!producerTrendByKey.has(key)) {
        producerTrendByKey.set(key, []);
      }
      producerTrendByKey.get(key)!.push(trend);
    });

    // Process stores with pre-indexed data
    this.sellThroughData = stores.map((store: any) => {
      const storeProducers =
        producersByStore.get(store.productionStoreID) || [];

      // Process store trend with pre-filtered data
      const storeTrendData = (
        storeTrendByStore.get(store.productionStoreID) || []
      ).map((trend: any) => ({
        date: this.datepipe.transform(trend.createdDate, 'MMM d')!,
        sellThroughPercentage: trend.sellThroughPercentage.toFixed(2)
      }));

      // Process producer trend with pre-indexed data
      const producerTrendData = storeProducers.map((producer: any) => {
        const key = `${store.productionStoreID}-${producer.userID}`;
        return {
          producerID: `${producer.userID}-${store.productionStoreID}`,
          data: (producerTrendByKey.get(key) || []).map((trend: any) => ({
            date: this.datepipe.transform(trend.createdDate, 'MMM d')!,
            sellThroughPercentage: trend.sellThroughPercentage.toFixed(2)
          }))
        };
      });

      // Calculate aggregates in a single pass
      let totalProducedQty = 0;
      let totalProducedPrice = 0;
      let totalAvgAmount = 0;
      let totalSoldQty = 0;
      let totalSoldPrice = 0;
      let totalDiscountedItems = 0;
      let totalDiscountedAmount = 0;
      let totalAvgDaysOnFloor = 0;
      let totalOnHandItemsAmount = 0;
      let totalPotentialRevenue = 0;

      storeProducers.forEach((producer: any) => {
        totalProducedQty += producer.producedQty || 0;
        totalProducedPrice += producer.producedPrice || 0;
        totalAvgAmount += producer.avgAmount || 0;
        totalSoldQty += producer.soldQty || 0;
        totalSoldPrice += producer.soldPrice || 0;
        totalDiscountedItems += producer.discountedItems || 0;
        totalDiscountedAmount += producer.discountedAmount || 0;
        totalAvgDaysOnFloor += producer.avgDaysOnFloor || 0;
        totalOnHandItemsAmount += producer.onHandItemsAmount || 0;
        totalPotentialRevenue += producer.potentialRevenue || 0;
      });

      const producerCount = storeProducers.length || 1;
      const avgSoldPrice =
        totalSoldQty !== 0 ? totalSoldPrice / totalSoldQty : 0;
      const avgAmount = totalAvgAmount / producerCount;
      const avgDaysOnFloor = totalAvgDaysOnFloor / producerCount;

      // Pre-format currency values
      const formatCurrency = (value: number) =>
        `$${value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`;

      return {
        storeID: store.productionStoreID,
        storeName: store.storeName,
        isProducersData: false,
        producers: storeProducers.map((p: any) => ({
          UserName: p.userName,
          UserID: p.userID
        })),
        storeTotal: [
          { columnId: 1, total: totalProducedQty },
          { columnId: 2, total: formatCurrency(totalProducedPrice) },
          { columnId: 3, total: formatCurrency(avgAmount) },
          { columnId: 4, total: totalSoldQty },
          { columnId: 5, total: formatCurrency(totalSoldPrice) },
          { columnId: 16, total: `$${avgSoldPrice.toFixed(2)}` },
          { columnId: 6, total: totalDiscountedItems },
          { columnId: 7, total: formatCurrency(totalDiscountedAmount) },
          { columnId: 10, total: avgDaysOnFloor.toFixed(2) },
          { columnId: 11, total: formatCurrency(totalOnHandItemsAmount) },
          { columnId: 12, total: formatCurrency(totalPotentialRevenue) },
          { columnId: 14, total: `${store.sellThroughPercentage.toFixed(2)}%` },
          { columnId: 15, total: storeTrendData }
        ],
        measuredValues: [
          {
            columnId: 1,
            data: storeProducers.map((p: any) => ({ value: p.producedQty }))
          },
          {
            columnId: 2,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.producedPrice)
            }))
          },
          {
            columnId: 3,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.avgAmount)
            }))
          },
          {
            columnId: 4,
            data: storeProducers.map((p: any) => ({ value: p.soldQty }))
          },
          {
            columnId: 5,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.soldPrice)
            }))
          },
          {
            columnId: 16,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.avgSoldPrice)
            }))
          },
          {
            columnId: 6,
            data: storeProducers.map((p: any) => ({
              value: p.discountedItems
            }))
          },
          {
            columnId: 7,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.discountedAmount)
            }))
          },
          {
            columnId: 10,
            data: storeProducers.map((p: any) => ({ value: p.avgDaysOnFloor }))
          },
          {
            columnId: 11,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.onHandItemsAmount)
            }))
          },
          {
            columnId: 12,
            data: storeProducers.map((p: any) => ({
              value: formatCurrency(p.potentialRevenue)
            }))
          },
          {
            columnId: 14,
            data: storeProducers.map((p: any) => ({
              value: `${p.sellThroughPercentage.toFixed(2)}%`
            }))
          },
          {
            columnId: 15,
            data: producerTrendData
          }
        ]
      };
    });
  }

  formateSellThroughModalData(department: any[], category: any[]) {
    // Pre-index categories by composite key for O(1) lookups
    const categoriesByDeptUser = new Map<string, any[]>();

    // Single pass through categories array
    category.forEach((ctg: any) => {
      const key = `${ctg.departmentID}-${ctg.createdByUserID}`;
      if (!categoriesByDeptUser.has(key)) {
        categoriesByDeptUser.set(key, []);
      }
      categoriesByDeptUser.get(key)!.push(ctg);
    });

    // Helper function to format currency
    const formatCurrency = (value: number) =>
      `$${value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;

    this.sellThroughDeptData = department.map((dept: any) => {
      const key = `${dept.departmentID}-${dept.createdByUserID}`;
      const deptCategories = categoriesByDeptUser.get(key) || [];

      // Calculate all aggregates in a single pass
      let totalProducedQty = 0;
      let totalProducedPrice = 0;
      let totalAvgAmount = 0;
      let totalSoldQty = 0;
      let totalSoldPrice = 0;
      let totalDiscountedItems = 0;
      let totalDiscountedAmount = 0;
      let totalAvgDaysOnFloor = 0;
      let totalOnHandItemsAmount = 0;
      let totalPotentialRevenue = 0;

      deptCategories.forEach((cat: any) => {
        totalProducedQty += cat.producedQty || 0;
        totalProducedPrice += cat.producedPrice || 0;
        totalAvgAmount += cat.avgAmount || 0;
        totalSoldQty += cat.soldQty || 0;
        totalSoldPrice += cat.soldPrice || 0;
        totalDiscountedItems += cat.discountedItems || 0;
        totalDiscountedAmount += cat.discountedAmount || 0;
        totalAvgDaysOnFloor += cat.avgDaysOnFloor || 0;
        totalOnHandItemsAmount += cat.onHandItemsAmount || 0;
        totalPotentialRevenue += cat.potentialRevenue || 0;
      });

      const categoryCount = deptCategories.length || 1;
      const avgAmount = totalAvgAmount / categoryCount;

      return {
        UserID: dept.createdByUserID,
        deptName: dept.departmentDescr,
        isCategoryData: false,
        categories: deptCategories.map((cat: any) => ({
          CategoryID: cat.categoryID,
          CategoryName: cat.categoryName
        })),
        deptTotal: [
          { columnId: 1, total: totalProducedQty },
          { columnId: 2, total: formatCurrency(totalProducedPrice) },
          { columnId: 3, total: formatCurrency(avgAmount) },
          { columnId: 4, total: totalSoldQty },
          { columnId: 5, total: formatCurrency(totalSoldPrice) },
          { columnId: 16, total: `$${dept.avgSoldPrice.toFixed(2)}` },
          { columnId: 6, total: totalDiscountedItems },
          { columnId: 7, total: formatCurrency(totalDiscountedAmount) },
          { columnId: 10, total: totalAvgDaysOnFloor },
          { columnId: 11, total: formatCurrency(totalOnHandItemsAmount) },
          { columnId: 12, total: formatCurrency(totalPotentialRevenue) },
          { columnId: 14, total: `${dept.sellThroughPercentage.toFixed(2)}%` }
        ],
        measuredValues: [
          {
            columnId: 1,
            data: deptCategories.map((cat: any) => ({
              value: cat.producedQty
            }))
          },
          {
            columnId: 2,
            data: deptCategories.map((cat: any) => ({
              value: `$${cat.producedPrice}`
            }))
          },
          {
            columnId: 3,
            data: deptCategories.map((cat: any) => ({
              value: formatCurrency(cat.avgAmount)
            }))
          },
          {
            columnId: 4,
            data: deptCategories.map((cat: any) => ({ value: cat.soldQty }))
          },
          {
            columnId: 5,
            data: deptCategories.map((cat: any) => ({
              value: formatCurrency(cat.soldPrice)
            }))
          },
          {
            columnId: 16,
            data: deptCategories.map((cat: any) => ({
              value: formatCurrency(cat.avgSoldPrice)
            }))
          },
          {
            columnId: 6,
            data: deptCategories.map((cat: any) => ({
              value: cat.discountedItems
            }))
          },
          {
            columnId: 7,
            data: deptCategories.map((cat: any) => ({
              value: formatCurrency(cat.discountedAmount)
            }))
          },
          {
            columnId: 10,
            data: deptCategories.map((cat: any) => ({
              value: cat.avgDaysOnFloor
            }))
          },
          {
            columnId: 11,
            data: deptCategories.map((cat: any) => ({
              value: formatCurrency(cat.onHandItemsAmount)
            }))
          },
          {
            columnId: 12,
            data: deptCategories.map((cat: any) => ({
              value: formatCurrency(cat.potentialRevenue)
            }))
          },
          {
            columnId: 14,
            data: deptCategories.map((cat: any) => ({
              value: `${cat.sellThroughPercentage.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}%`
            }))
          }
        ]
      };
    });
  }

  populateProducerModalTable(userObj: any, storeName: string) {
    this.modalStoreName = storeName;
    this.modalUserName = userObj.userName;
    this.sellThroughDeptTableData = this.sellThroughDeptData.filter(
      (item: { UserID: any }) => item.UserID === userObj.UserID
    );
  }

  setSellThroughChartParameters(obj: any, opt: number) {
    if (opt == 1) {
      this.chartStoreName = obj.storeName;
      this.storeID = obj.storeID;
      this.userID = 0;
      this.chartUserName = 'Over All';
    }
    if (opt == 2) {
      this.userID = obj.userID;
      this.chartUserName = obj.userName;
    }
    this.getSellThroughChart();
  }

  getSellThroughChart() {
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize

    const isStartToday =
      start.getFullYear() === today.getFullYear() &&
      start.getMonth() === today.getMonth() &&
      start.getDate() === today.getDate();

    const isEndToday =
      end.getFullYear() === today.getFullYear() &&
      end.getMonth() === today.getMonth() &&
      end.getDate() === today.getDate();

    if (isStartToday) {
      start.setDate(start.getDate() - 1);
    }

    if (isEndToday) {
      end.setDate(end.getDate() - 1);
    }

    const formattedStartDate = this.datepipe.transform(
      start,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      end,
      'yyyy-MM-dd HH:mm:ss'
    );

    this.masterService
      .getSellThroughChartV2(
        this.userInfo.companyID,
        this.storeID,
        this.userID,
        this.deptID.toString(),
        this.categoryId,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId
      )
      .subscribe(
        (res: any) => {
          const chartData = res.rates;
          if (chartData.length === 0) {
            this.noChartData = true;
          } else {
            this.noChartData = false;
          }
          /*  const sortedData = chartData.sort((a: { createdDate: string | number | Date; }, b: { createdDate: string | number | Date; }) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
           */
          // Map the sorted data to the desired format
          this.sellThroughChart = chartData.map(
            (item: {
              createdDate: string | number | Date;
              sellThroughPercentage: any;
            }) => {
              const date = new Date(item.createdDate);
              return {
                date: this.datepipe.transform(date, 'MMM d')!,
                sellThroughPercentage: item.sellThroughPercentage.toFixed(2)
              };
            }
          );

          this.updateChart();
        },
        (err) => {}
      );
  }

  updateChart() {
    this.destroyCharts();
    setTimeout(() => {
      this.renderChart();
    }, 100);
  }

  getUsersByStore(storeID: number) {
    this.sellThroughData.forEach((item: any) => {
      if (item.storeID === storeID) this.usersArray = item.producerSummaries;
    });
  }

  renderDynamicTrendChart(storeAndProducerTrend: any, topProducers: any) {
    storeAndProducerTrend.forEach((item: any) => {
      const storeId = item.storeID;
      const trend = item.storeTotal.find((t: any) => t.columnId === 15).total;
      this.renderTrendCharts(trend, storeId);
    });

    storeAndProducerTrend.forEach((item: any) => {
      const producerData = item.measuredValues
        .filter((item: any) => item.columnId == 15)
        .map((item2: any) => item2.data);

      producerData[0].forEach((res: any) => {
        this.renderTrendCharts(res.data, res.producerID);
      });
    });

    topProducers.forEach((item: any) => {
      const topProducerTrend = item.prdData
        .filter((d: any) => d.columnID == 7)
        .map((d2: any) => d2.value);
      topProducerTrend.forEach((res: any) => {
        this.renderTrendCharts(res.data, res.producerID);
      });
    });
  }

  renderTrendCharts(trend: any[], storeId: string) {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    const ctx = document.getElementById(storeId) as HTMLCanvasElement;

    if (!ctx) {
      console.error('Canvas element not found');
      return;
    }

    new Chart(ctx, {
      type: 'line',
      data: {
        labels: trend.map((item: { date: any }) => item.date),
        datasets: [
          {
            label: 'Sell through rate',
            data: trend.map((item) => item.sellThroughPercentage),
            backgroundColor: '#66BB6A',
            borderColor: '#66BB6A',
            pointRadius: 0,
            tension: 0.4
          }
        ]
      },
      options: {
        scales: {
          x: {
            display: false,
            border: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            display: false,
            border: {
              display: false
            },
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });
  }

  renderChart() {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    let chartData = this.sellThroughChart.map((item) => ({
      x: item.date,
      y: item.sellThroughPercentage
    }));

    // If there's only one data point, add a second "dummy" point
    if (chartData.length === 1) {
      chartData.push({ x: '', y: chartData[0].y * 0.99 }); // Use 'undefined' instead of 'null'
    }

    this.salesGraph = new Chart('salesStatistics', {
      type: 'line',
      data: {
        labels: chartData.map((item) => item.x),
        datasets: [
          {
            label: 'Sell through rate',
            data: chartData.map((item) => item.y),
            backgroundColor: '#66BB6A',
            borderColor: '#66BB6A',
            pointRadius: chartData.length === 1 ? 4 : 0, // Show dot if only one point
            spanGaps: true // Prevents chart from breaking if there’s only one point
          }
        ]
      },
      options: {
        scales: {
          x: {
            display: true,
            border: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            display: true,
            border: {
              display: false
            },
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });

    this.charts = [this.salesGraph];
  }

  destroyCharts() {
    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });

    this.charts = [];
  }

  changeSalesData(item: string, i: number) {
    this.reportTypeOption = item;
  }

  toggleProducersData(item: any) {
    item.isProducersData = !item.isProducersData;
  }

  toggleCategoryData(item: any) {
    item.isCategoryData = !item.isCategoryData;
  }

  getWeekColors() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.weekColorService
      .getProductionCycles(user.companyID)
      .subscribe((res) => {
        this.weekColorsList = res as ProductionCycle[];
        this.weekColorsList = this.weekColorsList.filter(
          (item) => item.status === OverrideStatus.Active
        );
      });
  }

  toggleAllColors() {
    this.weekColorHeaderSelected = !this.weekColorHeaderSelected;
    //i can disble date range here
    if (!this.disableCategory) this.disableCategory = true;
  }

  selectAllcolors() {
    this.weekColor = 'All Week Colors';
    this.productionCycleId = 0;
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }
}
